
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ActionHandler } from '@app/core/components/actions/action.handler';

@Injectable()
export class MasterSearch0Actions {
    constructor(
        private actionHandler: ActionHandler,
        
    ) {}



}